//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../Routing/Routing.BaseConnectionCompatibilityTable.js";
let d=[[[0,"SpecificationName",0,0],[0,"WeldGap",1,0]],[[["attribute1","attribute2","gasket","bolt","stud","nut","washers","weldRing","ringJoints"],"GetPostPlacementOptions",{},2,0],[["attribute1","attribute2","gasket","bolt","stud","nut","washers","weldRing","ringJoints"],"SetPostPlacementOptions",{},9,0],[["gasket","bolt","stud","nut","washers","ringJoints"],"GetReportInBom",{},0,0],[["gasket","bolt","stud","nut","washers","ringJoints"],"SetReportInBom",{},6,0],[["partType","startingNode","nSearchAttributes","searchAttributes"],"GetPostPlacementSearchCriteria",{},1,0],[["partType","startingNode","searchAttributes"],"SetPostPlacementSearchCriteria",{},3,0],[[],"Dispose",{},0,0]],[]];
SPLM.Routing.SpecificationConnectionCompatibilityTable = class extends SPLM.Routing.BaseConnectionCompatibilityTable{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.SpecificationConnectionCompatibilityTable";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;